export enum ESiteSettingsPaths {
  TAGS = 'tags',
  CUSTOM_FIELDS = 'custom-fields',
  USERS = 'users',
  PLAN = 'plan',
  LOGO = 'logo',
  INTEGRATIONS = 'integrations',
  IMPORT_POINTS = 'import-points',
}
